import { render, staticRenderFns } from "./IndicadoresResultadoPagination.vue?vue&type=template&id=3b5e06a6&"
import script from "./IndicadoresResultadoPagination.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResultadoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports